import {validateMaxLength} from '../../common/validationUtils';
import {messages} from '../common/Translations';
import {plainJSTranslator} from "../../common/PlainJSTranslator";

export const validation = values => {
    let errors = {};

    if (!values.name) {
        errors.name = plainJSTranslator.formatMessage(messages.enterName);
    }

    if (!values.description.replace(/\s|&nbsp;|(<([^>]+)>)/g, '')) {
        errors.description = plainJSTranslator.formatMessage(messages.descriptionRequired);
    }

    if(!values.categoryId) {
        errors.categoryId = plainJSTranslator.formatMessage(messages.required);
    }

    if (values.price) {
        if (values.price > 1000000000) {
            errors.price = plainJSTranslator.formatMessage(messages.priceTooHigh);
        }
    }

    if (values.quantity) {
        if (values.amount > 1000000000) {
            errors.amount = 'Quantity is to high';
        }
    }

    errors = validateMaxLength({
        values, errors, length: 255, fields: [
            'name',
            'description',
        ]
    });

    return errors;
};


// WEBPACK FOOTER //
// ./web/src/components/machine-rental/validation.js